// extracted by mini-css-extract-plugin
export default {"error-container":"error-container-e8f070c8","errorContainer":"error-container-e8f070c8"};